__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/aef23cf4c096f6c07c7ad3d8bf4d807f9526e1ab80ee059f31cdac63/";